import axios from 'axios';
import { baseUrl, token } from '../../../../services/Apis';

export const ptemaEvaluacionApi = `${baseUrl}/ptema-evaluaciones`;

export const allPtemEvaluacionesService = async (params) => {
  const res = await axios.get(ptemaEvaluacionApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const savePtemEvaluacionesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${ptemaEvaluacionApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(ptemaEvaluacionApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const onePtemEvaluacionesService = async (id) => {
  const res = await axios.get(`${ptemaEvaluacionApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deletePtemEvaluacionesService = async (id) => {
  const res = await axios.delete(`${ptemaEvaluacionApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
